// /enter/:token — ссылка входа из письма (030: FR-004, FR-007; research Р1, Р4): «Вы входите как …»
// и «Войти», без сеанса. Сосед /login и /invite/:token: /login/… занят страницей «Вход» (plan.md).
import { createFileRoute } from '@tanstack/react-router';
import { LinkLoginPage } from '../features/auth/LinkLoginPage.tsx';

export const Route = createFileRoute('/enter/$token')({
  component: EnterRoute,
});

function EnterRoute() {
  const { token } = Route.useParams();
  return <LinkLoginPage token={token} />;
}
